import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider } from './context/AuthContext'
import ProtectedRoute from './components/ProtectedRoute'
import Login from './pages/Login'
import Signup from './pages/Signup'
import ClinicianSignup from './pages/ClinicianSignup'
import ForgotPassword from './pages/ForgotPassword'
import ResetPassword from './pages/ResetPassword'
import SetPassword from './pages/SetPassword'
import Billing from './pages/Billing'
import ClinicianDashboard from './pages/ClinicianDashboard'
import PatientDashboard from './pages/PatientDashboard'
import PatientSchedule from './pages/PatientSchedule'
import ExerciseLibrary from './pages/ExerciseLibrary'
import NewExercise from './pages/NewExercise'
import EditExercise from './pages/EditExercise'
import TaskLibrary from './pages/TaskLibrary'
import NewTask from './pages/NewTask'
import EditTask from './pages/EditTask'
import ProgramTemplates from './pages/ProgramTemplates'
import NewProgramTemplate from './pages/NewProgramTemplate'
import EditProgramTemplate from './pages/EditProgramTemplate'
import PatientRoster from './pages/PatientRoster'
import PatientProgram from './pages/PatientProgram'
import ComplianceDashboard from './pages/ComplianceDashboard'
import ClinicCompliance from './pages/ClinicCompliance'
import Settings from './pages/Settings'
import { Capacitor } from '@capacitor/core'
import PatientHistory from './pages/PatientHistory'
import PatientSettings from './pages/PatientSettings'
import Home from './pages/Home'
import Terms from './pages/Terms'
import PatientConsent from './pages/PatientConsent'
import Privacy from './pages/Privacy'

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/signup/clinician" element={<ClinicianSignup />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/set-password" element={<SetPassword />} />
          <Route path="/billing" element={<Billing />} />
          <Route path="/clinician" element={
            <ProtectedRoute role="clinician"><ClinicianDashboard /></ProtectedRoute>
          } />
          <Route path="/clinician/exercises" element={
            <ProtectedRoute role="clinician"><ExerciseLibrary /></ProtectedRoute>
          } />
          <Route path="/clinician/exercises/new" element={
            <ProtectedRoute role="clinician"><NewExercise /></ProtectedRoute>
          } />
          <Route path="/clinician/exercises/:exerciseId/edit" element={
            <ProtectedRoute role="clinician"><EditExercise /></ProtectedRoute>
          } />
          <Route path="/clinician/interventions" element={
            <ProtectedRoute role="clinician"><TaskLibrary /></ProtectedRoute>
          } />
          <Route path="/clinician/interventions/new" element={
            <ProtectedRoute role="clinician"><NewTask /></ProtectedRoute>
          } />
          <Route path="/clinician/interventions/:interventionId/edit" element={
            <ProtectedRoute role="clinician"><EditTask /></ProtectedRoute>
          } />
          <Route path="/clinician/diagnoses" element={
            <ProtectedRoute role="clinician"><ProgramTemplates /></ProtectedRoute>
          } />
          <Route path="/clinician/diagnoses/new" element={
            <ProtectedRoute role="clinician"><NewProgramTemplate /></ProtectedRoute>
          } />
          <Route path="/clinician/diagnoses/:templateId/edit" element={
            <ProtectedRoute role="clinician"><EditProgramTemplate /></ProtectedRoute>
          } />
          <Route path="/clinician/patients" element={
            <ProtectedRoute role="clinician"><PatientRoster /></ProtectedRoute>
          } />
          <Route path="/clinician/patients/:patientId" element={
            <ProtectedRoute role="clinician"><PatientProgram /></ProtectedRoute>
          } />
          <Route path="/clinician/patients/:patientId/compliance" element={
            <ProtectedRoute role="clinician"><ComplianceDashboard /></ProtectedRoute>
          } />
          <Route path="/clinician/compliance" element={
            <ProtectedRoute role="clinician"><ClinicCompliance /></ProtectedRoute>
          } />
          <Route path="/clinician/settings" element={
            <ProtectedRoute role="clinician"><Settings /></ProtectedRoute>
          } />
          <Route path="/patient" element={
            <ProtectedRoute role="patient"><PatientDashboard /></ProtectedRoute>
          } />
          <Route path="/patient/schedule" element={
            <ProtectedRoute role="patient"><PatientSchedule /></ProtectedRoute>
          } />
          <Route path="/patient/history" element={
            <ProtectedRoute role="patient"><PatientHistory /></ProtectedRoute>
          } />
          <Route path="/patient/settings" element={
            <ProtectedRoute role="patient"><PatientSettings /></ProtectedRoute>
          } />
          <Route path="/terms" element={<Terms />} />
          <Route path="/consent" element={<PatientConsent />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/" element={Capacitor.isNativePlatform() ? <Navigate to="/login" /> : <Home />} />
          <Route path="*" element={<Navigate to="/login" />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  )
}
